/* <ff-slider>: scroll-snap slider with arrows, dots, autoplay.
   Attributes: data-autoplay (ms, optional), data-step="page|item" (default page), data-loop="true" */
if (!customElements.get('ff-slider')) {
class FFSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ff-track]');
    if (!this.track) return;
    this.prev = this.querySelector('[data-ff-prev]');
    this.next = this.querySelector('[data-ff-next]');
    this.dotsEl = this.querySelector('[data-ff-dots]');
    this.step = this.dataset.step || 'page';
    this.loop = this.dataset.loop === 'true';
    this.autoplay = parseInt(this.dataset.autoplay, 10) || 0;

    this.prev?.addEventListener('click', () => this.go(-1));
    this.next?.addEventListener('click', () => this.go(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => { this.buildDots(); this.update(); });
    this.resizeObserver.observe(this.track);

    if (this.autoplay) {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
    this.buildDots();
    this.update();
  }

  disconnectedCallback() { this.stop(); this.resizeObserver?.disconnect(); }

  get items() { return [...this.track.children]; }
  get stepSize() {
    const first = this.items[0];
    if (this.step === 'item' && first) return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
    return this.track.clientWidth;
  }
  get pages() { return Math.max(1, Math.round((this.track.scrollWidth - 1) / this.stepSize) || 1); }
  get page() { return Math.round(this.track.scrollLeft / this.stepSize); }
  get maxScroll() { return this.track.scrollWidth - this.track.clientWidth - 1; }

  go(dir) {
    const atEnd = this.track.scrollLeft >= this.maxScroll;
    if (dir > 0 && atEnd && this.loop) return this.track.scrollTo({ left: 0 });
    if (dir < 0 && this.track.scrollLeft <= 0 && this.loop) return this.track.scrollTo({ left: this.track.scrollWidth });
    this.track.scrollBy({ left: dir * this.stepSize });
  }

  goTo(i) { this.track.scrollTo({ left: i * this.stepSize }); }

  buildDots() {
    if (!this.dotsEl) return;
    const total = this.step === 'item' ? Math.ceil(this.track.scrollWidth / this.stepSize) : this.pages;
    if (this.dotsEl.children.length === total) return;
    this.dotsEl.innerHTML = '';
    this.dotsEl.hidden = total < 2;
    for (let i = 0; i < total; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ff-slider__dot';
      b.setAttribute('aria-label', (this.dataset.dotLabel || 'Slide %n%').replace('%n%', i + 1));
      b.addEventListener('click', () => this.goTo(i));
      this.dotsEl.appendChild(b);
    }
  }

  update() {
    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft >= this.maxScroll;
    const hidden = this.track.scrollWidth <= this.track.clientWidth + 1;
    if (this.prev) { this.prev.disabled = hidden || (atStart && !this.loop); }
    if (this.next) { this.next.disabled = hidden || (atEnd && !this.loop); }
    const p = this.page;
    this.dotsEl?.querySelectorAll('.ff-slider__dot').forEach((d, i) => d.setAttribute('aria-current', i === p ? 'true' : 'false'));
  }

  start() { this.stop(); if (this.autoplay && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.timer = setInterval(() => { this.loop = true; this.go(1); }, this.autoplay); }
  stop() { clearInterval(this.timer); }
}
customElements.define('ff-slider', FFSlider);
}
